import React, { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";

type Props = {
  data: { status?: string };
  HandleDataProps: (payload: { status: string }) => void;
  externalErrorId?: string;
};

const STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "closed", label: "Closed" },
];

const RequirementStatusChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const validationErrorHandle = useValidationErrorHandle();
  const [status, setStatus] = useState<string>(data?.status || "open");
  const [error, setError] = useState("");

  useEffect(() => {
    setStatus(data?.status || "open");
  }, [data?.status]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!status) {
        setError("Please select a status");
        return false;
      }
      setError("");
      return true;
    },
    submitForm: () => {
      const newData = { status };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div className="space-y-4">
      <p className="pt-4 text-base">Requirement Status</p>
      <select
        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring focus:border-blue-500"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">Select a status</option>
        {STATUS_OPTIONS.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </select>
      {(externalErrorId || error) && (
        <div className="text-red-500 text-sm mt-2">{externalErrorId ? validationErrorHandle(externalErrorId) : error}</div>
      )}
    </div>
  );
});

export default RequirementStatusChange;
